import { getIndentation } from './utils'

export const orderedRe = /^(\s*)(\d+)([.)])(\s+)/
export const bulletRe = /^(\s*)([-*+])(\s+)/

export const matchList = (line: string) => {
  return line.match(/^(\s*)([-*+]\s+|(\d+)([.)])\s+)/)
}

export const findFirstListMatch = (
  lines: string[],
): { index: number; match: RegExpMatchArray } | null => {
  for (let i = 0; i < lines.length; i++) {
    const m = matchList(lines[i])
    if (m) return { index: i, match: m }
  }
  return null
}

// Detect whether the current line is a continuation of a previous list item.
// A line is considered a continuation if:
//  - it is not itself a list line,
//  - it has some indentation, and
//  - there may exist previous lines with the same indentation level that are not a list line,
//    preceded (possibly via multiple same-indented non-list lines) by a list item whose indent is smaller.
export const findListItemStartLine = (
  text: string,
  lineStart: number,
  line: string,
): RegExpMatchArray | null => {
  const curIndent = getIndentation(line)
  if (!curIndent) return null

  const prevText = text.slice(0, lineStart)
  const prevLines = prevText.length ? prevText.split('\n') : []

  let i = prevLines.length - 1
  // ignore trailing empty when prevText ends with a newline
  if (i >= 0 && prevLines[i] === '') i--

  while (i >= 0) {
    const ln = prevLines[i]
    if (getIndentation(ln) === curIndent && !matchList(ln)) {
      i--
      continue
    }
    break
  }

  if (i >= 0) {
    const candidate = prevLines[i]
    const pm = matchList(candidate)
    if (pm) {
      const parentIndent = pm[1] || ''
      if (parentIndent.length < curIndent.length) return pm
    }
  }

  return null
}

export const buildNewListMarker = (
  fullMarker: string,
  numStr: string,
  delim: string,
  increaseNumber: boolean = false,
): string => {
  const nextNum = String(parseInt(numStr, 10) + 1)
  return increaseNumber && numStr ? `${nextNum}${delim} ` : fullMarker
}
